import { render, staticRenderFns } from "./SinglePeopleDisplay.vue?vue&type=template&id=57fb8807&scoped=true"
import script from "./SinglePeopleDisplay.vue?vue&type=script&lang=js"
export * from "./SinglePeopleDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fb8807",
  null
  
)

export default component.exports